import { createGlobalStyle } from 'styled-components';
import { normalize } from 'styled-normalize';

import Roboto700ttf from './fonts/Roboto-Bold.ttf';
import Roboto700ittf from './fonts/Roboto-BoldItalic.ttf';
import Roboto400ttf from './fonts/Roboto-Regular.ttf';
import Roboto400ittf from './fonts/Roboto-Italic.ttf';
import Roboto300ttf from './fonts/Roboto-Light.ttf';
import Roboto300ittf from './fonts/Roboto-LightItalic.ttf';
import Roboto100ttf from './fonts/Roboto-Thin.ttf';
import Roboto100ittf from './fonts/Roboto-ThinItalic.ttf';

export const GlobalStyle = createGlobalStyle`
  ${normalize}

  @font-face {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    src: url(${Roboto400ttf}) format('truetype');
  }

  @font-face {
    font-family: 'Roboto';
    font-style: italic;
    font-weight: 400;
    src: url(${Roboto400ittf}) format('truetype');
  }

  @font-face {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    src: url(${Roboto700ttf}) format('truetype');
  }

  @font-face {
    font-family: 'Roboto';
    font-style: italic;
    font-weight: 700;
    src: url(${Roboto700ittf}) format('truetype');
  }

  @font-face {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 300;
    src: url(${Roboto300ttf}) format('truetype');
  }

  @font-face {
    font-family: 'Roboto';
    font-style: italic;
    font-weight: 300;
    src: url(${Roboto300ittf}) format('truetype');
  }

  @font-face {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 100;
    src: url(${Roboto100ttf}) format('truetype');
  }

  @font-face {
    font-family: 'Roboto';
    font-style: italic;
    font-weight: 100;
    src: url(${Roboto100ittf}) format('truetype');
  }

  p {
    font-weight: 300;
  }

  h2 {
    font-weight: 500;
  }

  a {
    color: white;
    font-family: Roboto, sans-serif;
  }

  li {
    font-family: Roboto, sans-serif;
  }
`;
